export { default as default } from './MoveComponent.jsx';